import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top of the page whenever the route changes
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // Use "auto" or "smooth" for valid behavior
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
